module.exports = __webpack_public_path__ + "static/media/asf.989c3439.png";